import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, notification, Typography } from 'antd';
import { t } from 'i18next';
import { replace } from 'lodash';
import { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { data } from '../../configs/menu-config';
import { setUserData } from '../../redux/slices/auth';
import { fetchRestSettings, fetchSettings } from '../../redux/slices/globalSettings';
import authService from '../../services/auth';
const { Title, Text, Link } = Typography;



export default function OtpScreen() {
  const [otp, setOtp] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [timeLeft, setTimeLeft] = useState(300); 
  const navigate = useNavigate();
   const location = useLocation();
  const { uuid, email, password, number } = location.state || {};
  const dispath = useDispatch();

  useEffect(() => {
    const timer =
      timeLeft > 0 &&
      setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60)
      .toString()
      .padStart(2, '0');
    const secs = (seconds % 60).toString().padStart(2, '0');
    return `${mins}:${secs}`;
  };

   const handleResend = () => {
   
    setIsResending(true);
    try {
       console.log('values => ', );
       
       authService
      .login({ email: email, password: password })
      .then((res) => {
        setTimeLeft(300);
          notification.success({
            message: 'OTP sent successfully',
          });
      })
      .finally(() => setIsResending(false));
    } catch (error) {
       console.log('error => ', error);
       
       notification.error({
         message: 'Something went wrong',
         description: error.response.data.message
       })
    }
  };

  

  const handleVerify = () => {
    setIsVerifying(true);
    console.log('UUID:', uuid);

    if (otp.length !== 6) {
      setIsVerifying(false);
      notification.error({
        message: 'Please enter a valid OTP',
      });
      return;
    }

    if (uuid === undefined ) {
      setIsVerifying(false);
      notification.error({
        message: 'Please Login to continue',
      })
      navigate('/login' , { replace: true });
      return;
    }
    console.log('Verifying OTP:', otp);
    authService
      .verifyOtp({ otp: otp, uuid: uuid })
      .then((res) => {

         if (!res || !res.user) {
          console.log('res => ', res);
          
    notification.error({
      message: 'Invalid response from server.',
    });
    return;
  }
         
         const role = res.user.role;

         console.log('role jhol => ', role);
         
        const effectiveRole = role === 'manager' ? 'admin' : role;

        

        console.log('effectiveRole Jhol => ', effectiveRole);
        

       const user = {
  fullName: res.user.firstname + ' ' + res.user.lastname,
  role: role,
  urls: data[effectiveRole],
  img: res.user.img,
  token: res.access_token,
  email: res.user.email,
  id: res.user.id,
};

console.log('user => ', user);



        if (user.role === 'user') {
          notification.error({
            message: t('ERROR_101'),
          })
        
          return;
        }
        localStorage.setItem('token', res.access_token);
        // disp(setUserData(user));
       dispath  (setUserData(user));
        if (user.role === 'admin' || user.role === 'manager') {
         dispath (fetchSettings());
        } else {
         dispath (fetchRestSettings());
        }
      }).finally(() => setIsVerifying(false));
  };


  return (
    <div className='login-container'>
    <div className=" mx-auto container d-flex flex-column justify-content-center">
        <Card 
         style={{
           maxWidth: '450px',
         }}
        className="rounded-2xl p-4 w-full max-w-[580px] mx-auto ">
            <div className='flex justify-start'>
            <Button
              type="link"
              icon={<ArrowLeftOutlined />}
              className="p-0 mb-4"
              onClick={() => navigate('/login', replace(true))}
            >
              Back to login
            </Button>
            </div>

            <div className=''>
            <Title  level={3}>Two-Step Verification</Title>
            <Text type="secondary">Enter the verification code sent to your phone</Text>

            <div className="rounded-lg py-4 mt-4 text-start">
  <Text type="secondary">
    A 6-digit code has been sent to
  </Text>
  <br />
  <p className="font-bold" style={{ fontVariantLigatures: 'none' }}>
  {number}
</p>
</div>

            </div>

            <div className="mt-6 mb-4">
            <OTPInput
  value={otp}
  onChange={setOtp}
  numInputs={6}
  isInputNum
  containerStyle="flex justify-between gap-2 flex-wrap"
  renderInput={(props) => (
    <input
      {...props}
      style={{ width: '42px', height: '42px', backgroundColor: 'transparent' }} // inline style wins
      className="text-center text-black border border-gray-300 rounded-lg text-lg outline-none focus:ring-2 focus:ring-blue-500 "
    />
  )}
/>


            </div>

            <div className="flex justify-between items-center mb-4">
              <Text type="secondary">Code expires in: {formatTime(timeLeft)}</Text>
              <Button  
               
              type="link" onClick={handleResend} disabled={timeLeft > 0}>
             {isResending ? 'Resending...' : 'Resend code'}    
              </Button>
            </div>

            <Button 
              loading={isVerifying}
            type="primary" block onClick={handleVerify}>
              Verify and Continue
            </Button>

            <div className="text-center mt-4">
              <Text type="secondary">
                Having trouble? <Link>Contact Support</Link>
              </Text>
            </div>
        </Card>
    </div>
    </div>
  );


}



